import { render } from "./ShortTermCashView.vue?vue&type=template&id=3b81865e&ts=true"
import script from "./ShortTermCashView.vue?vue&type=script&lang=ts"
export * from "./ShortTermCashView.vue?vue&type=script&lang=ts"

import "./ShortTermCashView.vue?vue&type=style&index=0&id=3b81865e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__